<template>
	<div v-if="item">
		<v-container
			v-if="item.hero_image"
			fluid
			pa-0
		>
			<v-img
				:src="item.hero_image.url"
				:alt="item.hero_image.alt"
				aspect-ratio="1.33"
			/>
		</v-container>
		<v-container class="py-6">
			<h1
				v-if="item.title"
				class="headline mb-5"
			>
				{{item.title}}
			</h1>
			<p
				v-if="item.summary"
				class="subtitle-1 mb-6"
			>
				{{item.summary}}
			</p>
			<RichText
				:content="item.content"
			/>
			<v-list
				v-if="item.attachments && item.attachments.length"
				class="mt-4"
				flat
			>
				<template v-for="(file, index) in item.attachments">
					<v-list-item
						:key="file.url"
						:href="file.url"
						target="_blank"
					>
						<v-list-item-icon>
							<v-icon color="secondary">
								{{file.icon}}
							</v-icon>
						</v-list-item-icon>
						<v-list-item-content>
							<v-list-item-title>{{file.list_title}}</v-list-item-title>
							<v-list-item-subtitle>{{file.list_summary}}</v-list-item-subtitle>
						</v-list-item-content>
					</v-list-item>
					<v-divider
						v-if="index !== item.attachments.length - 1"
						:key="'divider-' + index"
						inset
					/>
				</template>
			</v-list>
			<SalaryCalculator
				v-if="item.show_salary_calculator === 1"
			/>
		</v-container>
	</div>
</template>

<script>

import { mapState } from 'vuex'
import RichText from '@/components/RichText'
import SalaryCalculator from '@/components/SalaryCalculator'

export default {
  name: 'Page',
	components: {
		RichText,
		SalaryCalculator,
	},
  data: () => ({
    error: '',
    item: null,
  }),
  computed: {
    ...mapState([
      'pages',
    ]),
  },
  mounted () {
    // Find current page from the store
    this.item = this.pages.find(item => {
      return item.name == this.$route.params.pagename
    })

    if (!this.item) {
      this.$router.replace({ name: 'Error404' })
    }

    this.loading = false
  },
};
</script>
